module.exports = __webpack_public_path__ + "static/media/gift.b4b032df.svg";